
export function submittingForm() {
  return {
    type: 'SUBMITING_FORM',
  };
}

export function submitFormSuccess(data) {
  return {
    type: 'SUBMIT_FORM_SUCCESS',
    data
  };
}

export function submitFormFailure() {
  return {
    type: 'SUBMIT_FORM_FAILED'
  };
}

export function fetchingPersonConsent() {
  return {
    type: 'FETCHING_PERSONCONSENT',
  };
}

export function fetchPersonConsentSuccess(data) {
  return {
    type: 'FETCH_PERSONCONSENT_SUCCESS',
    data
  };
}

export function fetchPersonConsentFailure() {
  return {
    type: 'FETCH_PERSONCONSENT_FAILED'
  };
}



// WEBPACK FOOTER //
// ./src/personconsent/PersonConsentActions.jsx